<script setup lang="ts">
import { customerServiceEmail } from '@lib/shared';

export type FleequidEmailType = 'info' | 'privacy' | 'withdrawal' | 'claims' | 'press' | 'pec' | 'accessibility' | 'customerService';

// PROPS
const { type } = defineProps({
    type: { type: String as PropType<FleequidEmailType>, required: true },
    label: { type: String, default: undefined },
});

// COMPUTED
const email = computed(() => {
    switch (type) {
        case 'info':
            return 'info@fleequid.com';
        case 'privacy':
            return 'privacy@fleequid.com';
        case 'withdrawal':
            return 'withdrawal@fleequid.com';
        case 'claims':
            return 'claims@fleequid.com';
        case 'press':
            return 'press@fleequid.com';
        case 'pec':
            return 'adorea@pecaruba.it';
        case 'accessibility':
            return 'accessibility@fleequid.com';
        case 'customerService':
            return customerServiceEmail;
    }
});
</script>

<template>
    <BaseEmailLink :email="email">
        <slot>{{ label ?? email }}</slot>
    </BaseEmailLink>
</template>
